var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-collection columns"},_vm._l((_vm.files),function(file){return _c('base-file',{key:file.id,staticClass:"column is-one-third",attrs:{"value":file,"deletable":_vm.deletable}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }